// extracted by mini-css-extract-plugin
export default {"eventDetails":"eventDetails_eventDetails__9HkJv","title":"eventDetails_title__b5g7e","content":"eventDetails_content__VS3YO","icon":"eventDetails_icon__BMKvm"};